// components/UserBasedRedirector.tsx
import { useAuth } from 'app/auth';
import { Navigate } from 'react-router-dom';
import { AppPermissions } from 'routing/AppPermissions';

export const UserBasedRedirector = () => {
  const { currentUser } = useAuth();

  const getRedirectPath = () => {
    switch (true) {
      case currentUser?.type === AppPermissions.types.tazmeenEmployee:
        return '/companies';
      case currentUser?.role === AppPermissions.roles.QcEmp:
        return '/manage-tasks';
      case currentUser?.role === AppPermissions.roles.ClientAdmin:
        return '/projects';
      default:
        return '/projects';
    }
  };

  return <Navigate to={getRedirectPath()} replace />;
};
